import Vue from 'vue'

// Central event dispatch → GA4 (gtag) + Microsoft Clarity. Analytics load
// directly via plugins/pls-analytics.client.js (prod). These events previously
// pushed to the GTM dataLayer ($gtm); GTM was removed, so we call gtag/clarity
// directly — same event names (pls_app_*) so GA4 reporting is unchanged.
function plsTrack(event){
  if (typeof window === 'undefined') return;
  if (typeof window.gtag === 'function') window.gtag('event', event);
  if (typeof window.clarity === 'function') {
    try { window.clarity('event', event); window.clarity('set', 'action', event); } catch (e) { /* clarity not ready */ }
  }
}

Vue.mixin({
  methods: {
    //easy way to track events site wide
    async pls_app_track(event_name){
      plsTrack('pls_app_'+event_name);
      // console.log("event tracked", event_name);
    },
    async pls_app_track_time(event_name, time){
      // TODO: track
    },
    async pls_track_get_affiliate(toString=true){
      var affiliate_ids = [];
      if (this.$cookies?.get('affiliate_id')) {
        affiliate_ids.push(this.$cookies?.get('affiliate_id'));
      }
      if (this.$cookies?.get('affiliate_ids')) {
        affiliate_ids = affiliate_ids.concat(this.$cookies?.get('affiliate_ids').split(","));
      }
      if (toString) {
        return affiliate_ids.join(",");
      }else{
        return affiliate_ids;
      }
    },
    // NOTE, this doesn't work unless you are on *.phonelivestreaming.com, such as local dev
    async pls_track_set_affiliate(affiliate_id) {
      //grab the current list of affiliate ids tracked
      var affiliate_ids = await this.pls_track_get_affiliate(false);
      // only add the affiliate id if it is not the last one in the list
      // and no need to (re) set the cookie if we aren't changing anything
      if (affiliate_ids[affiliate_ids.length-1] != affiliate_id) {
        affiliate_ids.push(affiliate_id);
        this.$cookies?.set(
          'affiliate_ids',
          affiliate_ids.join(","),
          {
            path: '/',
            domain: 'phonelivestreaming.com',
            maxAge: 60 * 60 * 24 * 90
          }
        );
        plsTrack('pls_app_affiliate_' + affiliate_id);
      }
    }
  }
})